import { DataLogRq, SourcePage } from '@domain/rq/DataLog';

export class ProfilePortfolioAttachFileSaveVO {
  fileUid: string;

  constructor(dto: ProfilePortfolioAttachFileSaveVO) {
    this.fileUid = dto.fileUid;
  }
}

export class ProfileCareerAttachFileSaveVO {
  fileUid: string;

  constructor(dto: ProfileCareerAttachFileSaveVO) {
    this.fileUid = dto.fileUid;
  }
}

export default class ProfileAttachFileSaveRq {
  portfolioAttachFiles: ProfilePortfolioAttachFileSaveVO[];
  referenceUrls: string[];
  careerAttachFiles: ProfileCareerAttachFileSaveVO[];
  sourcePage?: SourcePage;

  constructor(rq: ProfileAttachFileSaveRq & DataLogRq) {
    this.portfolioAttachFiles = rq.portfolioAttachFiles?.map((dto) => new ProfilePortfolioAttachFileSaveVO(dto)) ?? [];
    this.referenceUrls = rq.referenceUrls.filter((e, index) => rq.referenceUrls.indexOf(e) === index) ?? [];
    this.careerAttachFiles = rq.careerAttachFiles?.map((dto) => new ProfileCareerAttachFileSaveVO(dto)) ?? [];
    this.sourcePage = rq.sourcePage;
  }
}
